import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import SplitType from 'split-type'
import { runTextAnimation } from './text'
import { runSectionTitleAnimation } from './section-title'
import { setupBanner } from './fp-banner.js'
import { setupPostCardAnimation } from './post-card'
import { setupParallaxImages } from './parallax-image'
import { setupStickyBackButton } from './sticky-back-button'
import { breakpointDown, breakpointUp } from '../utils/breakpoints'

gsap.registerPlugin(ScrollTrigger)

function getFadeUpElements()
{
  return '.js-text-animate h4, .intro-container .js-text-animate a, .section-about .js-text-animate a, .js-block-fade-up, .js-block-fade-up-small'
}

function setSplitElements()
{
  return '.js-text-animate h1, .js-text-animate .h1, .js-text-animate h2, .js-text-animate h3'
}

function getSplitElements()
{
  return '.js-text-animate .js-line-animate'
}

/**
 * Todo: too many animations, needs cleanup
 * @param scroller
 */
function setupForAnimating(scroller)
{
  let splitContainerElements = setSplitElements()

  $(splitContainerElements).each(function (e){
    new SplitType(this, { types: 'lines', lineClass: 'js-line' })
  })

  $('.js-line').each(function (){
    $(this).html('<div class="js-line-animate">' + $(this).html() + '</div>')
  })

  let jsLastTrigger = $('.js-scroll-trigger').length
  let jsCurrentTrigger = 0
  let startPos = 'top-=100 60%'
  let endPos = 'bottom 50%'

  if(breakpointUp('lg')) {
    setTimeout(function (e) {

      gsap.utils.toArray('.js-scroll-trigger').forEach(element => {
        jsCurrentTrigger += 1

        function triggerAnimation () {
          runSectionTitleAnimation($(element))
          runTextAnimation($(element))

          if ($(element).hasClass('js-play-banner')) {
            setupBanner()
          }
        }

        // Recalculate last elements position for screens depending on viewport
        function recalculateLastElementTrigger () {
          let screenH = $(window).height()
          return 'top-=' + (screenH / 3).toFixed(0) + ' 60%'
        }

        if (jsCurrentTrigger === 1) {
          startPos = recalculateLastElementTrigger() // trigger position : viewport position
          endPos = 'bottom 30%'
        }

        if (jsCurrentTrigger === jsLastTrigger) {
          startPos = recalculateLastElementTrigger() // trigger position : viewport position
          endPos = 'bottom 30%'
        }

        ScrollTrigger.create({
          trigger: element,
          start: startPos,
          end: endPos,
          scroller: scroller,
          scrub: true,
          //markers: true,
          once: true,
          onEnter: triggerAnimation
        })

      })

    }, 200)

  } else {
    // Only animate top block

    gsap.utils.toArray('.js-scroll-trigger').forEach(element => {
      jsCurrentTrigger += 1

      function triggerAnimation () {
        runSectionTitleAnimation($(element))
        runTextAnimation($(element))

        if ($(element).hasClass('js-play-banner')) {
          setupBanner()
        }
      }

      // Recalculate last elements position for screens depending on viewport
      function recalculateLastElementTrigger () {
        let screenH = $(window).height()
        return 'top-=' + (screenH / 3).toFixed(0) + ' 60%'
      }

      if (jsCurrentTrigger === 1) {
        startPos = recalculateLastElementTrigger() // trigger position : viewport position
        endPos = 'bottom 30%'
      }

      if (jsCurrentTrigger === jsLastTrigger) {
        startPos = recalculateLastElementTrigger() // trigger position : viewport position
        endPos = 'bottom 30%'
      }

      ScrollTrigger.create({
        trigger: element,
        start: startPos,
        end: endPos,
        scroller: scroller,
        scrub: true,
        //markers: true,
        once: true,
        onEnter: triggerAnimation
      })

    })
  }


  setupPostCardAnimation()

  setupParallaxImages(scroller)

  setupStickyBackButton(scroller)

}


export { setupForAnimating, getFadeUpElements, getSplitElements }
